import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionsCreators } from "../../actions";
import strings from "../../helpers/Localization";

import ButtonSKA from "../../aGlobalDesign/Buttons/ButtonSKA";
import PaginationList from "../../aGlobalDesign/Pagination/PaginationList";
import TagChip from "../../aGlobalDesign/Tags/TagChip";

class SelectResourceDialog extends React.Component {

    constructor() {
        super();
        this.state = {
            showFilters: false,
            tags: null
        };
    }

    componentDidMount() {
        this.props.GetAllTags();
    }

    getContentTypes() {
        return [
            { id: 20, name: strings.imageTitle },
            { id: 30, name: strings.videoTitle },
            { id: 40, name: strings.pdfTitle }
        ];
    }

    render() {
        if (this.props.open) {
            return <div className="modal">
                <div className="modal-black-box"/>
                <div className="modal-container" style={{ maxWidth: "90%", margin: "auto" }}>
                    <div className="verticalFlexContainer" style={{ justifyContent: "center", width: "90vw", height: "80dvh" }}>
                        <PaginationList
                            isDialog
                            isInModal={true}
                            icon={this.props.icon}
                            title={this.props.title}
                            headerToggle={
                                [{
                                    type: "switch",
                                    name: strings.Filters,
                                    checked: this.state.showFilters,
                                    onClick: () => this.setState({ showFilters: !this.state.showFilters })
                                }]
                            }
                            forceWidth="calc(100% - 100px)"
                            tags={this.state.showFilters ? this.props.dictionaries.tags : null}
                            showFilter={["name", "contenttypeid", "tags", "switchDisplay"]}
                            onGetElements={
                                (pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess, secondary) =>
                                    this.props.GetContentsList(pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess, secondary)
                            }
                            onSavePagination={this.props.SaveContentPagination}
                            myElements={this.props.contents.contents}

                            onSpecialElementClick={(element) => this.props.onSelect(element)}

                            sortOptions={[
                                { sortName: "name", sortData: "null" },
                                { sortName: "langs", sortData: "null" },
                                { sortName: "contentGroupName", sortData: "null" },
                                { sortName: "lastdatemodified", sortData: "desc" },
                                { sortName: "lastModifiedBy", sortData: "null" },
                                { sortName: "contentTypeName", sortData: "null" }
                            ]}
                            filterOptions={this.state.showFilters ? [
                                { filterName: "name", filterType: "text", title: strings.name },
                                { filterName: "contenttypeid", filterType: "select", title: strings.SortContentType, list: this.getContentTypes() }
                            ] : []}

                            tableElement={(element, onReloadList) => {
                                const data = element && element.data ? JSON.parse(element.data) : {};
                                return [
                                    {
                                        colTitle: strings.SortContentType,
                                        sortIndex: 5,
                                        colContent: element ? element.content ? element.content.contentType.name : element.contentType.name : null,
                                        fixedWidth: "100px"
                                    },
                                    {
                                        colTitle: strings.SortPreview,
                                        fixedWidth: "75px",
                                        lockWidth: true,
                                        cellRenderer: ({ tableManager, stringvalue, field, data, column, colIndex, rowIndex }) => {
                                            const value = data[column.field];
                                            if (value && value.ThumbnailUri) {
                                                return <img src={value.ThumbnailUri} alt="Avatar" style={{ height: "40px", width: "40px", borderRadius: "50%" }}/>;
                                            }
                                            else {return "";}
                                        },
                                        colContent: data
                                    },
                                    {
                                        colTitle: strings.SortName,
                                        sortIndex: 0,
                                        colContent: element ? element.name : null,
                                        fixedWidth: "300px"
                                    },
                                    {
                                        colTitle: strings.tags,
                                        fixedWidth: "200px",
                                        cellRenderer: ({ tableManager, stringvalue, field, data, column, colIndex, rowIndex }) => {
                                            const value = data[column.field];
                                            if (value) {
                                                return <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
                                                    {value.tags.map((tag, index) => {
                                                        return <TagChip key={index} tagName={tag.value}/>;})}
                                                </div>;
                                            }
                                            else {return "";}
                                        },
                                        colContent: element ? { tags: element.tags } : null
                                    },
                                    {
                                        colTitle: strings.SortDateCreated,
                                        sortIndex: 3,
                                        fixedWidth: "140px",
                                        lockWidth: true,
                                        colContent: element && element.dateCreated ? this.props.parseDate(element.dateCreated) : ""
                                    },
                                    {
                                        colTitle: strings.SortCreatedBy,
                                        sortIndex: 4,
                                        flex: "1",
                                        colContent: element && element.creator ? element.creator.email : null
                                    },
                                    {
                                        colTitle: "select",
                                        colType: "button",
                                        fixedWidth: "140px",
                                        lockWidth: true,
                                        lockRight: true,
                                        cellRenderer: ({ tableManager, stringvalue, field, data, column, colIndex, rowIndex }) => {
                                            const value = data[column.field];
                                            if (value) {
                                                return <ButtonSKA
                                                    type="secondary"
                                                    onClick={() => this.props.onSelect(value)}
                                                    text={strings.selectButton}
                                                />;
                                            }
                                            else {return "";}
                                        },
                                        colContent: element
                                    }
                                ];
                            }}
                            onClose={this.props.onClose}
                        />
                    </div>
                </div>
            </div>;
        }
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ActionsCreators, dispatch);
};

export default connect(
    (state) => state,
    mapDispatchToProps
)(SelectResourceDialog);
